
import { useState, useEffect } from 'react';
import { fetchJitoAPY } from '../lib/jito';

export const useJitoAPY = () => {
  const [apy, setApy] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadAPY = async () => {
      try {
        const data = await fetchJitoAPY();
        if (data !== null) {
          setApy(data);
        } else {
          setError('Failed to fetch APY');
        }
      } catch (err) {
        setError('Error loading APY');
      } finally {
        setLoading(false);
      }
    };

    loadAPY();
  }, []);

  // Format APY as percentage with 2 decimal places
  // If loading or error, fallback to "~7%" (historical average)
  const formattedApy = apy 
    ? `${(apy * 100).toFixed(2)}%` 
    : '~7%';

  return { apy, loading, error, formattedApy };
};
